// Quest definitions database
export const QUESTS = {
    slime_slayer: {
        id: 'slime_slayer',
        name: 'Slime Slayer',
        description: 'The village is overrun with slimes! Help us by defeating 3 of them.',
        level: 1,
        giverNpcId: 'village_elder',
        turnInNpcId: 'village_elder',
        objectives: [
            {
                type: 'kill',
                targetId: 'slime',
                targetName: 'Slimes',
                required: 3,
            },
        ],
        rewards: {
            experience: 100,
            gold: 25,
            items: [
                { itemId: 'health_potion', quantity: 3 },
            ],
        },
    },
    slime_samples: {
        id: 'slime_samples',
        name: 'Slime Research',
        description: 'Collect slime samples for the village alchemist.',
        level: 1,
        giverNpcId: 'village_elder',
        turnInNpcId: 'village_elder',
        objectives: [
            {
                type: 'collect',
                targetId: 'slime_goo',
                targetName: 'Slime Goo',
                required: 5,
            },
        ],
        rewards: {
            experience: 75,
            gold: 15,
            items: [
                { itemId: 'mana_potion', quantity: 2 },
            ],
        },
        prerequisiteQuestIds: ['slime_slayer'],
    },
};
//# sourceMappingURL=quests.js.map